import { useEffect, useRef } from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../utils/auth/msalConfig";
import { useNavigate } from "react-router-dom";

function AuthRedirect() {
  const { instance, accounts, inProgress } = useMsal();
  const navigate = useNavigate();
  const loginAttempted = useRef(false);

  useEffect(() => {
    if (accounts && accounts.length > 0) {
      const redirect = sessionStorage.getItem("postLoginRedirect");
      sessionStorage.removeItem("postLoginRedirect");

      if (redirect) {
        sessionStorage.removeItem("postLoginRedirect");
        // go to product catalog
        navigate(redirect, { replace: true });
        return;
      }
      navigate("/",{ replace: true });
    } else if (inProgress === "none" && !loginAttempted.current) {
      loginAttempted.current = true;
      instance.loginRedirect(loginRequest).catch((e) => {
        loginAttempted.current = false; // allow retry if needed
        // Optionally handle error
        console.error("Login failed:", e);
      });
    }
  }, [accounts, instance, navigate, inProgress]);

  return <div>Redirecting to Microsoft login...</div>;
}

export default AuthRedirect;